"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateConvertResponseToJSON = exports.TemplateConvertResponseFromJSONTyped = exports.TemplateConvertResponseFromJSON = exports.instanceOfTemplateConvertResponse = exports.attributeTypeMapTemplateConvertResponse = void 0;
var TemplateConvertResultResponse_1 = require("./TemplateConvertResultResponse");
var TemplateConvertFileErrorResponse_1 = require("./TemplateConvertFileErrorResponse");
exports.attributeTypeMapTemplateConvertResponse = [
    {
        name: "status",
        type: "string",
    },
    {
        name: "message",
        type: "string",
    },
    {
        name: "timestamp",
        type: "number",
    },
    {
        name: "reportLink",
        type: "string",
    },
    {
        name: "results",
        type: "Array<TemplateConvertResultResponse>",
    },
    {
        name: "fileErrors",
        type: "Array<TemplateConvertFileErrorResponse>",
    },
];
/**
 * Check if a given object implements the TemplateConvertResponse interface.
 */
function instanceOfTemplateConvertResponse(value) {
    if (!("status" in value) || value["status"] === undefined)
        return false;
    if (!("message" in value) || value["message"] === undefined)
        return false;
    if (!("timestamp" in value) || value["timestamp"] === undefined)
        return false;
    if (!("reportLink" in value) || value["reportLink"] === undefined)
        return false;
    if (!("results" in value) || value["results"] === undefined)
        return false;
    return true;
}
exports.instanceOfTemplateConvertResponse = instanceOfTemplateConvertResponse;
function TemplateConvertResponseFromJSON(json) {
    return TemplateConvertResponseFromJSONTyped(json, false);
}
exports.TemplateConvertResponseFromJSON = TemplateConvertResponseFromJSON;
function TemplateConvertResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        status: json["status"],
        message: json["message"],
        timestamp: json["timestamp"],
        reportLink: json["report_link"],
        results: json["results"].map(TemplateConvertResultResponse_1.TemplateConvertResultResponseFromJSON),
        fileErrors: json["file_errors"] == null
            ? undefined
            : json["file_errors"].map(TemplateConvertFileErrorResponse_1.TemplateConvertFileErrorResponseFromJSON),
    };
}
exports.TemplateConvertResponseFromJSONTyped = TemplateConvertResponseFromJSONTyped;
function TemplateConvertResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        status: value["status"],
        message: value["message"],
        timestamp: value["timestamp"],
        report_link: value["reportLink"],
        results: value["results"].map(TemplateConvertResultResponse_1.TemplateConvertResultResponseToJSON),
        file_errors: value["fileErrors"] == null
            ? undefined
            : value["fileErrors"].map(TemplateConvertFileErrorResponse_1.TemplateConvertFileErrorResponseToJSON),
    };
}
exports.TemplateConvertResponseToJSON = TemplateConvertResponseToJSON;
